/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!****************************************!*\
  !*** ./src/js/featured-collections.js ***!
  \****************************************/
document.addEventListener('DOMContentLoaded', function () {
  var productTabBlocks = Array.from(document.querySelectorAll('[data-product-tab-block]'));
  productTabBlocks.forEach(function (block) {
    var productTabs = Array.from(block.querySelectorAll('[data-product-tabTop]'));
    var productTabContents = Array.from(block.querySelectorAll('[data-product-TabContent]'));
    productTabs.forEach(function (tab, index) {
      tab.addEventListener('click', function (event) {
        event.preventDefault();
        productTabs.forEach(function (tab) {
          return tab.classList.remove('tab-active');
        });
        productTabContents.forEach(function (content) {
          return content.classList.remove('tab-active');
        });
        this.classList.add('tab-active');
        var target = document.querySelector(this.dataset.target);
        target.classList.add('tab-active');
        fetchData(this.dataset.href, target);
      });

      // if (index === 0) {
      //     tab.classList.add('tab-active');
      //     const target = document.querySelector(tab.dataset.target);
      //     target.classList.add('tab-active');
      //     fetchData(tab.dataset.href, target);
      // }
    });
  });
});

function fetchData(url, target) {
  if (!target.classList.contains('prods-loaded')) {
    var placeholder = target.querySelector('.placeholder');
    placeholder.classList.remove('hidden');
    //placeholder.classList.add('flex');

    fetch(url, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) {
      return response.text();
    }).then(function (data) {
      placeholder.classList.add('hidden');
      //placeholder.classList.remove('flex');

      var productsLoad = target.querySelector('.products-load');
      productsLoad.innerHTML = data;

      // fire a window event to listen in other files (like quickbuy-modal)
      window.dispatchEvent(new CustomEvent('featuredCollectionTabChange'));
      target.classList.add('prods-loaded');
    })["catch"](function (err) {
      console.error('An error occurred:', err);
      placeholder.classList.add('hidden');
      //placeholder.classList.remove('flex');
      target.querySelector('.products-load').innerHTML = 'An error occurred while loading data.';
    });
  }
}
/******/ })()
;